import { Component, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormService } from '../../../service/FormService';
import { DataToSaveService } from '../../../service/data-to-save.service';
import { SavedFilesApi } from '../../saved-files/saved-files.api';
import { MatDialog } from '@angular/material';
import { TrackingService } from '../../../service/tracking.service';

@Component({
  selector: 'app-file-name',
  templateUrl: './file-name.component.html',
  styleUrls: ['./file-name.component.css'],
  providers: [FormService, SavedFilesApi]
})

export class FileNameComponent  {

  fileName: string;
  fileType = 'csv';

  @ViewChild('fileNameForm') form: NgForm;
  constructor(private formService: FormService, private dataToSaveService: DataToSaveService,
              private savedFilesApi: SavedFilesApi, private dialog: MatDialog, private trackingService: TrackingService) {
  }

  saveFile() {
    this.formService.setTouched(this.form);
    if (!this.form.valid) return;
    const data = this.dataToSaveService.getData();
    this.savedFilesApi.save(data, this.fileType, this.fileName).subscribe(res => {
      this.dataToSaveService.emitFileNameEvent(res.file_name);
    });
    this.dialog.closeAll();
    this.trackingService.fileSaved();
  }

  changeFileType(filetype: string) {
    this.fileType = filetype;
  }
}



// WEBPACK FOOTER //
// /var/www/apps/asna/front-end/public_html/src/app/components/header/file-name/file-name.component.ts